// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperLinkElement-cls1_Bkv","cls2":"PaperLinkElement-cls2_MT1 PaperLinkElement-cls1_Bkv"};